
import Vue from 'vue'
import CallBlock from '../call-block/call-block.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'CallBlockList',
  components: { CallBlock },
  mixins: [staticBlockMixin],
  props: {
    imageLimit: {
      type: Boolean,
      required: false,
      default: false
    },
    alignImage: {
      type: Boolean,
      required: true,
      default: false
    }
  }
})
